"use client";

import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { ArrowRight, Building2, User } from "lucide-react";
export default function TuSocioEstrategicoParaGrandesDesafios() {
  const [serviceScale, setServiceScale] = useState<"corporate" | "individual">("corporate");
  const subHeadlines = {
    corporate: "מענה מקצועי ומהיר להשגחה פרטית בבתי חולים בחדרה והסביבה. צוות מטפלים מיומן הזמין עבורכם לכל צורך רפואי דחוף.",
    individual: "טיפול סיעודי אישי ומסור בבית המטופל בחדרה. אנחנו דואגים ליקירכם בסביבה הטבעית שלהם עם ליווי צמוד ותומך."
  };
  return <section data-section-id="225574" id="מטפל-סיעודי-בחדרה-פתרון-מיידי" className="bg-background text-foreground relative min-h-screen flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-background to-background z-0 pointer-events-none" />
      <div className="absolute inset-0 z-0 opacity-5 pointer-events-none" style={{
      backgroundImage: `linear-gradient(to right, currentColor 1px, transparent 1px), linear-gradient(to bottom, currentColor 1px, transparent 1px)`,
      backgroundSize: '40px 40px',
      maskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, #000 70%, transparent 110%)',
      WebkitMaskImage: 'radial-gradient(ellipse 80% 50% at 50% 0%, #000 70%, transparent 110%)'
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 py-24 lg:py-0">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center min-h-[calc(100vh-6rem)]">
          
          {}
          <div className="flex flex-col justify-center space-y-10 max-w-2xl">
            
            {}
            <div className="inline-flex flex-col space-y-3">
              <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider font-mono">
                סוג השירות המבוקש
              </span>
              <div className="bg-card/40 backdrop-blur-md border border-border/50 p-1 rounded-lg inline-flex shadow-md w-fit">
                <ToggleGroup type="single" value={serviceScale} onValueChange={value => value && setServiceScale(value as "corporate" | "individual")} className="gap-1">
                  <ToggleGroupItem value="corporate" aria-label="השגחה בבית חולים" className="px-6 py-2.5 rounded-md data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:shadow-sm transition-all duration-300 gap-2 font-default">
                    <Building2 className="w-4 h-4" />
                    השגחה בבית חולים
                  </ToggleGroupItem>
                  <ToggleGroupItem value="individual" aria-label="טיפול בבית" className="px-6 py-2.5 rounded-md data-[state=on]:bg-primary data-[state=on]:text-primary-foreground data-[state=on]:shadow-sm transition-all duration-300 gap-2 font-default">
                    <User className="w-4 h-4" />
                    טיפול בבית
                  </ToggleGroupItem>
                </ToggleGroup>
              </div>
            </div>

            {}
            <div className="space-y-6">
              <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold font-default tracking-tight text-primary leading-[1.1]">
                מטפל סיעודי בחדרה<br />תוך 5 שעות.
              </h1>
              
              <div className="relative min-h-[100px]">
                <p className={`text-lg sm:text-xl text-muted-foreground font-default leading-relaxed transition-all duration-500 absolute inset-0 ${serviceScale === 'corporate' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
                  {subHeadlines.corporate}
                </p>
                <p className={`text-lg sm:text-xl text-muted-foreground font-default leading-relaxed transition-all duration-500 absolute inset-0 ${serviceScale === 'individual' ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}`}>
                  {subHeadlines.individual}
                </p>
              </div>
            </div>

            {}
            <div className="flex flex-wrap gap-4 pt-4">
              <Button asChild size="lg" className="rounded-lg px-8 h-12 text-base shadow-lg shadow-primary/10 font-default">
                <a href="/ContactPage">
                  הזמנת מטפל עכשיו
                  <ArrowRight className="mr-2 w-4 h-4 rotate-180" />
                </a>
              </Button>
              <Button asChild size="lg" variant="outline" className="rounded-lg px-8 h-12 text-base bg-transparent border-border hover:bg-accent backdrop-blur-sm font-default">
                <a href="/NursingCaregiverHodHasharonWithinHoursPage">
                  מידע נוסף בחדרה
                </a>
              </Button>
            </div>
          </div>

          {}
          <div className="relative h-[50vh] lg:h-[85vh] w-full rounded-lg overflow-hidden border border-border/20 shadow-xl group">
            <div className="absolute inset-0 bg-gradient-to-tr from-background/40 via-transparent to-transparent z-10 transition-opacity duration-500 group-hover:opacity-60" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/hadera_nursing_care_specialist.png" alt="מטפל סיעודי מקצועי בחדרה מעניק תמיכה למטופל" className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105" />
            
            {}
            <div className="absolute bottom-8 left-8 right-8 z-20 flex justify-between items-end">
              <div className="bg-card/80 backdrop-blur-md border border-border p-4 rounded-lg shadow-md">
                <p className="text-primary font-mono text-xs tracking-widest uppercase opacity-80">
                  זמינות מיידית
                </p>
                <p className="text-foreground font-default font-medium mt-1">
                  פתרון סיעודי בחדרה
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}